import { useEffect, useState } from "react";
import { Button,Heading } from "@chakra-ui/react";

import { Link, useNavigate } from "react-router-dom";
import "../cart.css"
import axios from "axios";
const products = JSON.parse(localStorage.getItem("nikeprod"))||[]


let Cart = () => {
  const [total, setTotal] = useState(0);
  const [cart, setCart] = useState([]);
  var totalCartPrice = 0;

  useEffect(() => {
    async function getCart(){
      const token=localStorage.getItem("isLogged");
      if(token){
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        let res=await axios.get("https://real-cyan-rooster-ring.cyclic.app/getfromcart")
        // console.log(k.data);
        const data=res.data
        console.log(data);
        setCart(data.nikeprod);
        setTotal(totalCartPrice);
      }
    }
    getCart()
  }, []);
  const navigate=useNavigate()
  const handleClick=()=>{
    navigate("/checkout")
  }

  let dlItem = (index) => {
    let newList = cart.filter((e, i) => {
      return index !== i;
    });
    setCart(newList);
    setTotal((p) => p - cart[index].Price);
  };

  const handleDecrement = (cart_id) => {
    setCart((cart) =>
      cart.map((item) =>
        cart_id === item.id
          ? {
              ...item,
              quantity: item.quantity - (item.quantity > 1 ? 1 : 0),
            }
          : item
      )
    );
    setTotal(totalCartPrice);
  };
  const handleIncrement = (cart_id) => {
    setCart((cart) =>
      cart.map((item) =>
        cart_id === item.id
          ? {
              ...item,
              quantity:
                item.quantity + (item.quantity < 10 ? 1 : 0),
            }
          : item
      )
    );
    setTotal(totalCartPrice);
  };

  return (
    <>
      <h3 style={{ textAlign: "center" }}>Bag</h3>
      <div id="cartContainer">
        <div id="myproducts">
          {cart.map((e, i) => {
            totalCartPrice += e.Price * e.quantity;
            return (
              <div key={i} id="mypdts">
                <div className="pdChild">
                  <img src={e.Image} alt={e.id} />
                </div>

                <div id="cartDec">
                  <p id="myTitle">
                    <b>{e.Title}</b>
                  </p>
                  <p id="myDes">{e.Title1}</p>
                  <p>{e.decp}</p>
                  <div
                    style={{ display: "flex", justifyContent: "space-between",alignItems:"center" }}
                  >
                    <label>
                      <b>Size: </b>
                    </label>
                    <select name="Select Size" id="">
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <label>
                      <b>Quantity:</b>{" "}
                    </label>
                    <Button onClick={() => handleDecrement(e.id)}>-</Button>
                    <button>{e.quantity}</button>
                    <Button onClick={() => handleIncrement(e.id)}>+</Button>
                  </div>
                  <br />
                </div>
                <div
                  style={{ textAlign: "right", width: "100%", height: "20px" }}
                >
                  <p>{`   MRP: ₹ ${e.Price}`}</p>
                  {/* <img  src={}  alt={e.id} onClick={()=>{dlItem(i)}}/> */}
                </div>
              </div>
            );
          })}
        </div>

        <div id="myTotal">
          <Heading as="h2" size={"lg"} mb={4} >Summary</Heading>
          <div style={{gap:"5px",marginBottom:"10px"}} id="mySummary">
            <p>Subtotal</p>
            <p style={{textAlign:"end"}}>{totalCartPrice}</p>
            <p>Handling</p>
            <p style={{textAlign:"end"}}>Free </p>
            <p>Total</p>
            <p style={{textAlign:"end"}}>{totalCartPrice}</p>
          </div>
          <div>
            {/* <Link to="/payment"> */}
            <button
              style={{
                backgroundColor: "black",
                color: "white",
                borderRadius: "80px",
                width: "100%",
                padding: "15px",
              }}
              onClick={handleClick}
            >
              Member Checkout
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
